var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContent',{style:({ paddingBottom: '300px' }),attrs:{"title":_vm.$t('conversations.title'),"conversations-main-page":""}},[_c('ListAmenityConversations',{attrs:{"amenityID":parseInt(_vm.amenityID)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }